import type { MessageItem } from "../session/MessageItem.js"

export class MessageFactory {

    /**
     * 默认 AI 欢迎消息
     */
    public static createDefaultMsg(): MessageItem {
        return {
            role: "ai",
            content: "ご利用ありがとうございます。mcframe Data Copilotです。\n何かお手伝いできることはございますか？",
            isStreaming: false,
            statusText: "",
            msgType: "0",
            chartData: null,
            field: null,
            title: "",
            subTitle: ""
        }
    }

    /**
     * 创建用户消息
     */
    public static createUserMsg(content: string): MessageItem {
        return {
            role: "user",
            content,
            isStreaming: false,
            statusText: "",
            msgType: "0",
            chartData: null,
            field: null,
            title: "",
            subTitle: ""
        }
    }

    /**
     * 创建 AI 消息
     */
    public static createAiMsg(): MessageItem {
        return {
            role: "ai",
            content: "",
            isStreaming: false,
            statusText: "",
            msgType: "0",
            chartData: null,
            field: null,
            title: "",
            subTitle: ""
        }
    }

}